import WysiwygEditor from './WysiwygEditor';

export default WysiwygEditor;
